import React from 'react';
import { createRoot } from 'react-dom/client';
import { AdminDashboard, type AdminDashboardProps } from '../ui/admin/AdminDashboard';

/**
 * AdminDashboardContainer - Entry point for rendering admin dashboard in Rails
 */
export function AdminDashboardContainer(props: AdminDashboardProps) {
  return <AdminDashboard {...props} />;
}

/**
 * Mount function for rendering from Rails
 */
export function mountAdminDashboard(
  container: HTMLElement,
  props: AdminDashboardProps
) {
  const root = createRoot(container);
  root.render(<AdminDashboardContainer {...props} />);
  return root;
}

export default AdminDashboardContainer;
